import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Criteria'],
});
export const criteriaApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllCriteria: builder.query({
      query: () => `dms_configurations/`,
      keepUnusedDataFor: 0,
      providesTags: ['Criteria'],
    }),
    updateCriteria: builder.mutation({
        query: (payload) => ({
          url: `dms_configurations/${payload.id}/`,
          method: 'PUT',
          body: { value: payload.value },
        }),
        invalidatesTags: ['Criteria'],
      }),

  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFindAllCriteriaQuery, useUpdateCriteriaMutation } =
  criteriaApi;
